<template>
  <div class="rank-detail">
    <div class="tab-list">
      <div
        class="tab-item"
        v-for="(item, index) in tabList"
        :key="index"
        @click="handleTab(item, index)"
        :class="index == tabIndex ? 'tab-active' : ''"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="collapse">
      <a-collapse expand-icon-position="right" :bordered="false">
        <template #expandIcon="props">
          <div class="collapse-reduce" v-if="props.isActive">
            <a-icon type="minus" style="font-size: 12px;color: #fff;" />
          </div>
          <div class="collapse-add" v-else>
            <a-icon type="plus" style="font-size: 12px;color: #fff;" />
          </div>
        </template>

        <a-collapse-panel :key="item.id" :style="customStyle" v-for="(item, index) in dataList">
          <template #header="props">
            <div
              class="match-title"
              :style="{
                backgroundColor: props.isActive ? '#31383f' : '#fff',
                color: props.isActive ? ' #fff' : '#31383f',
              }"
            >
              <div class="left">{{ item.rankName }}</div>
            </div>
          </template>
          <div class="record">
            <div class=" record-item record-title">
              <div class="l-1">排名</div>
              <div class="l-2">编号</div>
              <div class="l-3">运动员</div>
              <div class="l-4">成绩(评分)</div>
            </div>
            <div
              class="record-item"
              v-for="(i, j) in item.rankPlayerList"
              :key="j"
              :style="{ backgroundColor: j % 2 == 0 ? '#F3F5F7' : '' }"
            >
              <div class="l-1">{{ i.rank }}</div>
              <div class="l-2">{{ i.playerNum }}</div>
              <div class="l-3">
                <img :src="i.playerHead" alt="" />
                <div>
                  <div>{{ i.playerName }}</div>
                  <div>{{ i.agencyName }}</div>
                </div>
              </div>
              <div class="l-4" v-if="i.totalScore || i.rankScore">
                {{ i.totalScore ? i.totalScore : '-' }}({{ i.rankScore ? i.rankScore : '-' }})
              </div>
              <div class="l-4" v-else>-</div>
            </div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId),
      tabList: [
        {
          id: 1,
          name: '个人单项',
          rankType: 'signRank',
        },
        {
          id: 2,
          name: '个人全能',
          rankType: 'signAll',
        },
        {
          id: 3,
          name: '荣誉称号',
          rankType: 'honor',
        },
      ],
      tabIndex: 0,
      dataList: [],
      rankType: null,
      customStyle: 'background-color:#31383F;color:#fff;border: 0;overflow: hidden;',
    }
  },
  components: {},
  mounted() {
    this.rankType = this.tabList[0].rankType
    this.getbodyExamStandardMatchRank()
  },
  methods: {
    //获取数据方法
    handleTab(item, index) {
      this.tabIndex = index
    },
    async getbodyExamStandardMatchRank() {
      let data = {
        matchId: this.matchId,
        rankType: this.rankType,
      }
      try {
        let res = await this.$api.match.bodyExamStandardMatchRank(data)
        console.log('getbodyExamStandardMatchRank', res.data)

        if (res.status == 0) {
          this.dataList = res.data
        }
      } catch (error) {
        console.log('error', error)
      }
    },
  },
  watch: {
    tabIndex(newIndex) {
      console.log(`时间Index: ${newIndex}`)
      this.rankType = this.tabList[newIndex].rankType

      this.getbodyExamStandardMatchRank()
    },
  },
}
</script>

<style scoped lang="scss">
.rank-detail {
  width: 1200px;
  margin: 0 auto;
  .tab-list {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    padding: 20px 0;
    box-sizing: border-box;
    .tab-item {
      width: 110px;
      height: 36px;
      background-color: #f3f5f7;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .tab-active {
      background-color: #bd0600;
      color: #fff;
      font-weight: bold;
    }
  }
  .collapse {
    width: 100%;
    padding-bottom: 30px;
    box-sizing: border-box;
    .collapse-reduce {
      width: 18px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background-color: #31383f;
      border: 2px solid #fff;
    }
    .collapse-add {
      width: 18px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background-color: #fff;
      border: 2px solid #31383f;
    }
    .match-title {
      background-color: #fff;
      border-bottom: 2px solid #31383f;
      color: #31383f;
      height: 56px;
      padding-left: 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 80px;
      box-sizing: border-box;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-weight: bold;
        font-size: 18px;
      }
    }
    .record {
      width: 100%;
      box-sizing: border-box;
      background-color: #fff;
      .record-item {
        width: 100%;
        height: 72px;
        font-size: 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 30px;
        box-sizing: border-box;
        .l-1 {
          width: 10%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .l-2 {
          width: 15%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .l-3 {
          width: 60%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            width: 38px;
            height: 50px;
            margin-right: 10px;
            object-fit: cover;
            object-position: center;
          }
        }
        .l-4 {
          width: 15%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .record-title {
        font-size: 18px;
        height: 56px;
        font-weight: bold;
        border-bottom: 2px solid #31383f;
      }
    }
  }
}
/deep/ .ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
  padding: 0 !important;
}
/deep/ .ant-collapse-content > .ant-collapse-content-box {
  padding: 0 !important;
}
/deep/ .ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  width: 18px;
  height: 18px;
  background-color: #31383f;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/PhysicalFitness/components/RankDetail.vue